import { FormsModule } from '@angular/forms';
import { SelectBoxComponent } from './select-box.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SelectBoxComponent],
  imports: [CommonModule, FormsModule],
  exports: [SelectBoxComponent],
})
export class SelectBoxModule {}
